import config from "lib/config"
import {
  BookOpenCheck,
  Building2,
  ChartLine,
  ChartNoAxesCombined,
  Database,
  FileSpreadsheet,
  FlagTriangleRight,
  FlaskConical,
  HandCoins,
  Headset,
  HeartPulse,
  Logs,
  Mail,
  MailQuestion,
  PencilRuler,
  Route,
  Search,
} from "lucide-react"
import { AdminOnly } from "modules/shared/components/AdminOnly"
import { NavLink } from "modules/shared/components/Nav/Sidebar"
import { GoogleIcon } from "modules/shared/icons/google"
import { OutlookIcon } from "modules/shared/icons/outlook"
import { useTranslation } from "react-i18next"
import { BackofficeSection } from "./BackofficeSection"

export const Backoffice = () => {
  const { t } = useTranslation()

  const internalTools: NavLink[] = [
    {
      icon: Building2,
      title: t("backoffice.organizations.title"),
      url: "/backoffice/organizations/list",
    },
    {
      icon: ChartLine,
      title: t("backoffice.bi.title"),
      url: "/backoffice/bi",
    },
    {
      icon: Headset,
      title: t("backoffice.support.title"),
      url: "/backoffice/support/list",
    },
    {
      icon: BookOpenCheck,
      title: t("backoffice.knowledge.title"),
      url: "/backoffice/knowledge",
    },
    {
      icon: FlagTriangleRight,
      title: t("backoffice.flags.title"),
      url: "/backoffice/flags",
    },
    {
      icon: HeartPulse,
      title: t("backoffice.campaigns.health.title"),
      url: "/backoffice/campaigns/health",
    },
    {
      icon: PencilRuler,
      title: t("backoffice.capabilityExecutions.title"),
      url: "/backoffice/capabilityExecutions",
    },
    {
      icon: HandCoins,
      title: t("backoffice.referrals.title"),
      url: "/backoffice/referrals/list",
    },
    {
      icon: Route,
      title: t("backoffice.whatsappRoutes.title"),
      url: "/backoffice/whatsappRoutes",
    },
  ]

  const devTools: NavLink[] = [
    {
      icon: Logs,
      title: t("backoffice.bullmq.title"),
      externalUrl: `${config.apiEndpoint}/queues`,
    },
    {
      icon: Search,
      title: t("backoffice.jobSearch.title"),
      url: "/backoffice/jobSearch",
    },
    {
      icon: FileSpreadsheet,
      title: t("backoffice.scheduledReports.iconTitle"),
      url: "/backoffice/scheduledReports/list",
    },
    {
      icon: ChartNoAxesCombined,
      title: t("backoffice.conversationSalesReports.iconTitle"),
      url: "/backoffice/conversationSalesReports",
    },
    {
      icon: FlaskConical,
      title: t("backoffice.conversationExperiments.title"),
      url: "/backoffice/conversationExperiments/list",
    },
    {
      icon: Database,
      title: t("backoffice.clusters.title"),
      url: "/backoffice/clusters",
    },
    {
      icon: GoogleIcon,
      title: t("backoffice.gmailReader.title"),
      url: "/backoffice/gmailReader",
    },
    {
      icon: OutlookIcon,
      title: t("backoffice.outlookReader.title"),
      url: "/backoffice/outlookReader",
    },
    {
      icon: Mail,
      title: t("backoffice.emailPreview.title"),
      externalUrl: `${config.apiEndpoint}/email-preview`,
    },
    {
      icon: MailQuestion,
      title: t("backoffice.emailVerifier.iconTitle"),
      url: "/backoffice/emailVerifier",
    },
  ]

  return (
    <div className="space-y-12">
      <BackofficeSection
        titleKey="backoffice.internal.title"
        descKey="backoffice.internal.description"
        items={internalTools}
      />
      <AdminOnly superadminOnly>
        <>
          <BackofficeSection
            titleKey="backoffice.developerTools.title"
            descKey="backoffice.developerTools.description"
            items={devTools}
          />
        </>
      </AdminOnly>
    </div>
  )
}
